import React, {Component} from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import InstantNewsFeedContainer from './InstantNewsFeedContainer';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import {fetchInstantNewsLatestFeed, checkSourceGroup, fetchInstantNewsSourceGroup} from '../actions';

const container = connect(
  createSelector(
    (state) => ({
      sourceGroups: _.get(state, 'home.instantNews.sourceGroup'),
      checkSource: _.get(state, 'home.sourceGroup'),
      permission: _.get(state, 'me.permission'),
      subjects: _.get(state, 'subject.entities'),
    }),
    (state) => {
      const {sourceGroups, checkSource, permission} = state;
      const subjectId = _.get(permission, 'layout.panel_row1_left');
      const subject = state.subjects[subjectId] || {};
      const sourceGroupLabel = _.get(subject, 'sourceGroupLabel')
      const subjectSources = _.get(subject, 'queries.news.source');
      let subjectsourceGroups = [];
      _.map(subjectSources, (subjectSource) => {
        if (_.get(subjectSource, 'sourceGroupId')) {
          subjectsourceGroups = [...subjectsourceGroups, _.get(sourceGroups, `byId[${_.get(subjectSource, 'sourceGroupId')}]`)]
        }
      })
      const sourceGroup = _.keyBy(subjectsourceGroups, 'name');
      const sourceGroupById = _.get(sourceGroups, 'byId');
      return {
        sourceGroup, sourceGroupById, checkSource, sourceGroupLabel
      }
    }
  )
)

class InstantNewsLayout extends Component {

  componentWillMount() {
    const {dispatch, sourceGroupLabel} = this.props;
    dispatch(fetchInstantNewsSourceGroup({label: sourceGroupLabel}))
  }

  diapatchInstantNewsFeed = (action) => {
    const {dispatch} = this.props;
    dispatch(fetchInstantNewsLatestFeed(action));
  }

  dispatchSourceGroup = (data) => {

    const {dispatch, sourceGroup} = this.props;
    let sourceGroupId = ''
    if (data !== '') {
      sourceGroupId = sourceGroup[data].id;

    }
    dispatch(checkSourceGroup(sourceGroupId));
  }

  render() {
    const {dispatch, checkSource, sourceGroupById, sourceGroup} = this.props;
    const sourceGroupArray = _.keys(sourceGroup);
    return (
      <div>
        <div>
          <div className={classnames('panel-item', "first-blue", {"panel-item-active": checkSource == ''})} onClick={() => this.dispatchSourceGroup('')}>即時新聞</div>
          {_.map(_.take(sourceGroupArray, 5), (value) => {
            return (
              <div className={classnames('panel-item', "second-blue", {"panel-item-active": _.get(sourceGroupById, `[${checkSource}]name`) == value})} onClick={() => this.dispatchSourceGroup(value)}>{value}</div>
            )
          })
          }
        </div>
        <div style={{background: '#fff',paddingTop: "10px", minHeight: '380px', marginRight: '10px'}}>
          <InstantNewsFeedContainer dispatch={this.diapatchInstantNewsFeed} originDispatch={dispatch}/>
        </div>
      </div>
    )
  }
}

export default container(InstantNewsLayout)



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/InstantNewsLayout.js
 **/